import {
  GET_TELECONSULT,
  GET_TELECONSULT_FAIL,
  GET_TELECONSULT_SUCCESS,
  GET_TELECONSULT_DETAILS,
  GET_TELECONSULT_DETAILS_FAIL,
  GET_TELECONSULT_DETAILS_SUCCESS,
  ADD_NEW_TELECONSULT,
  ADD_TELECONSULT_SUCCESS,
  ADD_TELECONSULT_FAIL,
  UPDATE_TELECONSULT,
  UPDATE_TELECONSULT_SUCCESS,
  UPDATE_TELECONSULT_FAIL,
  DELETE_TELECONSULT,
  DELETE_TELECONSULT_SUCCESS,
  DELETE_TELECONSULT_FAIL,
  CONFIRM_TELECONSULT,
  CONFIRM_TELECONSULT_SUCCESS,
  CONFIRM_TELECONSULT_FAIL, 
  COMPLETE_TELECONSULT,
  COMPLETE_TELECONSULT_SUCCESS,
  COMPLETE_TELECONSULT_FAIL,
  ADD_REMARKS_TELE_APPOINTMENTS,
  ADD_REMARKS_TELE_APPOINTMENTS_SUCCESS,
  ADD_REMARKS_TELE_APPOINTMENTS_FAIL,
  RESET_TELECONSULT_STATE,
} from "./actionTypes";

export const getTeleconsult = ({ length, sort, page, name, date, status,sort_order }) => ({
  type: GET_TELECONSULT,
  payload: { length, sort, page, name, date, status,sort_order },
});

export const getTeleconsultSuccess = teleconsult => ({
  type: GET_TELECONSULT_SUCCESS,
  payload: teleconsult,
});

export const getTeleconsultFail = error => ({
  type: GET_TELECONSULT_FAIL,
  payload: error,
});

export const getTeleconsultDetails = ({ id }) => ({
  type: GET_TELECONSULT_DETAILS,
  payload: { id },
});

export const getTeleconsultDetailsSuccess = teleconsult => ({
  type: GET_TELECONSULT_DETAILS_SUCCESS,
  payload: teleconsult,
});

export const getTeleconsultDetailsFail = error => ({
  type: GET_TELECONSULT_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewTeleconsult = teleconsult => ({
  type: ADD_NEW_TELECONSULT,
  payload: teleconsult,
});

export const addTeleconsultSuccess = teleconsult => ({
  type: ADD_TELECONSULT_SUCCESS,
  payload: teleconsult,
});

export const addTeleconsultFail = error => ({
  type: ADD_TELECONSULT_FAIL,
  payload: error,
});

//update 
export const updateTeleconsult = ({ id, teleconsult }) => ({
  type: UPDATE_TELECONSULT,
  payload: { id, teleconsult },
});

export const updateTeleconsultSuccess = teleconsult => ({
  type: UPDATE_TELECONSULT_SUCCESS,
  payload: teleconsult,
});

export const updateTeleconsultFail = error => ({
  type: UPDATE_TELECONSULT_FAIL,
  payload: error,
});

//delete 
export const deleteTeleconsult = ({ id, msg }) => ({
  type: DELETE_TELECONSULT,
  payload: { id, msg },
});

export const deleteTeleconsultSuccess = teleconsult => ({
  type: DELETE_TELECONSULT_SUCCESS,
  payload: teleconsult,
});

export const deleteTeleconsultFail = error => ({
  type: DELETE_TELECONSULT_FAIL,
  payload: error,
});

//confirm 
export const confirmTeleconsult = ({ id, teleconsult }) => ({
  type: CONFIRM_TELECONSULT,
  payload: { id, teleconsult },
});

export const confirmTeleconsultSuccess = teleconsult => ({
  type: CONFIRM_TELECONSULT_SUCCESS,
  payload: teleconsult,
});

export const confirmTeleconsultFail = error => ({
  type: CONFIRM_TELECONSULT_FAIL,
  payload: error,
});

//complete 
export const completeTeleconsult = ({ id, teleconsult }) => ({
  type: COMPLETE_TELECONSULT,
  payload: { id, teleconsult },
});

export const completeTeleconsultSuccess = teleconsult => ({
  type: COMPLETE_TELECONSULT_SUCCESS,
  payload: teleconsult,
});

export const completeTeleconsultFail = error => ({
  type: COMPLETE_TELECONSULT_FAIL,
  payload: error,
});


//remarks 
export const addRemakrsTeleAppointments = ({ id, teleconsult }) => ({
  type: ADD_REMARKS_TELE_APPOINTMENTS,
  payload: { id, teleconsult },
});

export const addRemakrsTeleAppointmentsSuccess = teleconsult => ({
  type: ADD_REMARKS_TELE_APPOINTMENTS_SUCCESS,
  payload: teleconsult,
});

export const addRemakrsTeleAppointmentsFail = error => ({
  type: ADD_REMARKS_TELE_APPOINTMENTS_FAIL,
  payload: error,
});


//reset
export const resetTeleconsultState = () => {
  return {
    type: RESET_TELECONSULT_STATE,
  }
}


